/// <amd-module name="Widgets/VelocityWidget/VelocityWidget" />
import { WidgetProps } from "Dashboards/WidgetContracts/WidgetProps";
import * as React from "react";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import VelocityViewComponent from "./VelocityWidgetComponents/VelocityViewComponent";

export class VelocityWidget extends VssComponent<WidgetProps, {}> {
    public static readonly componentType = "velocityWidget";

    public constructor(props: WidgetProps, context: IVssComponentContext) {
        super(props, context);
    }

    public render(): JSX.Element | null {
        return (
            <VelocityViewComponent
                {...this.props}
                context={this.context.pageContext}
                suppressAnimations={!this.props.showLoadAnimations}
                onRenderCompletion={this.props.onWidgetLoaded}
            />
        );
    }
}

VssComponent.register(VelocityWidget.componentType, VelocityWidget);
